import AwardV2Icon from './component.jsx'
export default AwardV2Icon
